import Nav from "../components/verlo/Nav";
import OpeningStatement from "../components/verlo/OpeningStatement";
import BuiltAround from "../components/verlo/BuiltAround";
import TheProblem from "../components/verlo/TheProblem";
import Chapter from "../components/verlo/Chapter";
import BrandMarquee from "../components/verlo/BrandMarquee";
import Intelligence from "../components/verlo/Intelligence";
import Bridge from "../components/verlo/Bridge";
import Node from "../components/verlo/Node";
import Connect from "../components/verlo/Connect";
import EmotionalMoment from "../components/verlo/EmotionalMoment";
import Comparison from "../components/verlo/Comparison";
import CustomerStories from "../components/verlo/CustomerStories";
import Pricing from "../components/verlo/Pricing";
import Faq from "../components/verlo/Faq";
import ClosingCta from "../components/verlo/ClosingCta";
import Footer from "../components/verlo/Footer";
import CookieBanner from "../components/verlo/CookieBanner";

export default function Home() {
  return (
    <div className="bg-paper" data-testid="home-page">
      <Nav />
      <main>
        <OpeningStatement />
        <BuiltAround />
        <TheProblem />

        <Chapter
          id="front-of-house"
          number="I"
          title="Front of House"
          problem="During service the floor moves faster than the till can keep up. Orders sit, tables wait."
          solution="Verlo puts the whole floor on one calm surface, so a server can look after guests, not a screen."
          image="https://images.unsplash.com/photo-1647427017067-8f33ccbae493?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwyfHxwb3MlMjBwb2ludCUyMG9mJTIwc2FsZSUyMHRlcm1pbmFsJTIwcmVzdGF1cmFudHxlbnwwfHx8fDE3ODQ5MDE5ODN8MA&ixlib=rb-4.1.0&q=85"
          imageAlt="A point of sale terminal in use during service"
          imageSide="right"
          outcome="Calmer services. Evenings that end on time."
        />

        <Chapter
          id="back-office"
          number="II"
          title="Back Office"
          problem="Restaurants throw profit in the bin every day, because nobody sees the waste until it is gone."
          solution="What sells on the floor updates your stock, costs and rotas at once. The paperwork mostly does itself."
          image="https://images.pexels.com/photos/2696064/pexels-photo-2696064.jpeg"
          imageAlt="Two chefs plating dishes in a busy professional kitchen"
          imageSide="left"
          outcome="Less admin. Tighter margins. More time for the craft."
        />

        <BrandMarquee />

        <Intelligence />
        <Bridge />
        <Node />
        <Connect />

        <EmotionalMoment />

        <Comparison />
        <CustomerStories />
        <Pricing />
        <Faq />
        <ClosingCta />
      </main>
      <Footer />
      <CookieBanner />
    </div>
  );
}
